import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Translate, getActiveLanguage } from "react-localize-redux";
// import { Gmaps, Marker } from "react-gmaps"

// import BannerImage from "../../images/about-header@2x.png"
import Map1Image from "../../images/map-1.png";
import Map2Image from "../../images/map-2.png";
import Map3Image from "../../images/map-3.png";

const abbottOutlets = [
  {
    name: "Abbott Outlet 1",
    image: Map1Image,
    address: ["address 1"],
    email: "email1@abbott.com.sg",
    phone: "+65 1234 5678",
    hours: "10.30 AM - 10 PM daily",
    coords: {
      lat: 1.302313,
      lng: 103.83739
    },
    href: "https://www.abbott.com.sg/pages/outlet1"
  },
  {
    name: "Abbott Outlet 2",
    image: Map2Image,
    address: ["address 2"],
    email: "email2@abbott.com.sg",
    phone: "+65 1234 5678",
    hours: "10.30 AM - 10 PM daily",
    coords: {
      lat: 1.302313,
      lng: 103.83739
    },
    href: "https://www.abbott.com.sg/pages/outlet2"
  },
  {
    name: "Abbott Outlet 3",
    image: Map3Image,
    address: ["address 3"],
    email: "email3@abbott.com.sg",
    phone: "+65 1234 5678",
    hours: "10.30 AM - 10 PM daily",
    coords: {
      lat: 1.302313,
      lng: 103.83739
    },
    href: "https://www.abbott.com.sg/pages/outlet3"
  }
];

class AboutUs extends React.Component {
  render() {
    return (
      <div id="about">
        <section className="section-banner mx--3 mb-4">
          <img src="https://via.placeholder.com/2049x522" alt="About Banner" />
        </section>
        <div className="row justify-content-center mt-3">
          <div className="col-12 col-xl-11">
            {/* --- Page Content starts here --- */}

            <div className="row justify-content-center section mb-4 pb-4">
              <div className="text-center col-12 col-xl-8 col-lg-10 mb-2 mt-2">
                <h4 className="mb-3">
                  <Translate id="aboutUs._howItWorksTitle" />
                </h4>

                <div className="font-sub">
                  <Translate id="aboutUs._howItWorksMessage" />
                </div>
              </div>
            </div>
            <div className="row address justify-content-center section mb-4 pb-4">
              <div className="text-center col-12 col-xl-12 col-lg-12 mb-2 mt-2">
                <h4 className="text-center mb-3">
                  <Translate id="aboutUs._whereToPurchase" />
                </h4>
                {abbottOutlets.map((outlet, id) => {
                  return (
                    <div className="mb-3">
                      <h5>{outlet.name}</h5>
                      <div className="row mt-3">
                        <div className="col-12 col-md-6 col-lg-5 map">
                          <img src="https://via.placeholder.com/348x297" />
                          {/* <Gmaps
														width={"22rem"}
														height={"22rem"}
														lat={outlet.coords.lat}
														lng={outlet.coords.lng}
														zoom={14}>
														<Marker
															lat={outlet.coords.lat}
															lng={outlet.coords.lng}
															draggable={true}
														/>
													</Gmaps> */}
                        </div>
                        <div className="col-12 col-md-6 col-lg-5 map-info">
                          {outlet.address.map(address => {
                            return <p>{address}</p>;
                          })}
                          <br />
                          {outlet.email}
                          <br />
                          Email: {outlet.email}
                          <br />
                          Telp: {outlet.phone}
                          <br />
                          Hours: {outlet.hours}
                          <br />
                          For more info, click <a href={outlet.href}>here</a>.
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="row justify-content-center section mb-4 pb-4">
              <div className="text-center col-12 col-xl-8 col-lg-10 mb-2 mt-2">
                <h4 className="mb-3">
                  <Translate id="aboutUs._corporateOrdersTitle" />
                </h4>

                <div className="font-sub">
                  <p>
                    <Translate id="aboutUs._corporateOrdersMessage._1" />
                  </p>
                  <p>
                    <Translate id="aboutUs._corporateOrdersMessage._2" />
                  </p>
                  <p>
                    <Translate id="aboutUs._corporateOrdersMessage._3" />
                  </p>
                </div>
              </div>
            </div>
            <div className="row justify-content-center section mb-4 pb-4">
              <div className="text-center col-12 col-xl-12 col-lg-10 mb-4 mt-2">
                <h4 className="mb-3">
                  <Translate id="aboutUs._faqTitle" />
                </h4>

                <div className="font-sub faq">
                  <p className={"question"}>
                    &bull; How much can I load on a abbott Gift Card?
                  </p>
                  <p className={"answer"}>
                    Minimum Load: SGD 20
                    <br />
                    Maximum Load: SGD 1,000
                  </p>
                  <p className={"question"}>
                    &bull; Where can I use my abbott Gift Card?
                  </p>
                  <p className={"answer"}>
                    abbott Gift Card(s) are accepted across all abbott stores in
                    Singapore.
                    <br />
                    Click{" "}
                    <a
                      href="https://web4.ascentis.com.sg/abbotgiftcard/en/about"
                      target="_blank"
                    >
                      here
                    </a>{" "}
                    to find out where you could shop using a abbott Gift Card in
                    Singapore.
                  </p>
                  <p className={"question"}>
                    &bull; What is the validity of a abbott Gift Card?
                  </p>
                  <p className={"answer"}>
                    abbott Gift Card(s) are valid for a period of 12 months from
                    date of issuance.
                  </p>
                  <p className={"question"}>
                    &bull; Do I need to activate my abbott Gift Card prior to
                    use?
                  </p>
                  <p className={"answer"}>
                    It is strongly recommended to register your gift card prior
                    to use. Once registered, you will be able to manage your
                    abbott Gift Card(s) directly from your mobile device (i.e.,
                    enquire for balances and/or mark your abbott Gift Card as
                    Lost/Stolen).
                  </p>
                  <p className={"question"}>
                    &bull; How could I enquire the balance on my abbott Gift
                    Card(s)?
                  </p>
                  <p className={"answer"}>
                    There are several avenues to check on the balances of your
                    abbott Gift Card(s).
                    <ul>
                      <li>
                        By using your smartphone to scan the QR code on the back
                        of your abbott Gift Card
                      </li>
                      <li>
                        By visiting{" "}
                        <a
                          href="http://www.abbott.com.sg/gift-card"
                          target="_blank"
                        >
                          www.abbott.com.sg/gift-card
                        </a>{" "}
                        and logging into your account{" "}
                      </li>
                      <li>
                        Visit a Customer Service Desk at any abbott store in
                        Singapore
                      </li>
                    </ul>
                  </p>
                  <p className={"question"}>
                    &bull; Where do I find my 8-digit security code?
                  </p>
                  <p className={"answer"}>
                    The 8-digit abbott Gift Card security code is required when
                    you register your Gift Card online. The security code is
                    protected by a security foil found on the reverse of your
                    abbott Gift Card. Remove the security foil to access the
                    code.
                  </p>
                  <p className={"question"}>
                    &bull; My abbott Gift Card has expired – what should I do?
                  </p>
                  <p className={"answer"}>
                    abbott Gift Card(s) are deemed invalid upon expiry of the
                    cards. You may, however, avail of a grace period of 90 days
                    from the expiry date for re-activation of your expired
                    abbott Gift Card(s) upon successful payment of SGD 5 (as
                    re-activation fee).
                    <br />
                    Please note that the existing balance on your abbott Gift
                    Card needs to be more than SGD 5 to avail this facility and
                    the re-activation fee will be deducted from the balance upon
                    re-activation.
                    <br />
                    You may review a copy of the terms and conditions by
                    clicking 
                    <a
                      href="https://www.abbott.com.sg/pages/terms-conditions"
                      target="_blank"
                    >
                      here
                    </a>
                    .
                  </p>
                  <p className={"question"}>
                    &bull; Can I get a refund for the available balance on the
                    abbott Gift Card?
                  </p>
                  <p className={"answer"}>
                    We do not offer refunds once funds have been loaded onto the
                    card. The available balance can be utilized to make
                    purchases across all abbott store in Singapore, during the
                    validity and grace period (subject to successful
                    re-activation).
                  </p>
                  <p className={"question"}>
                    &bull; I have lost/had my abbott Gift Card stolen – what
                    should I do?
                  </p>
                  <p className={"answer"}>
                    If you have lost / had your abbott Gift Card stolen, please
                    follow the following steps:
                    <ul>
                      <li>
                        Login to your abbott Gift Card account and mark the card
                        as lost/stolen. This action will block your abbott Gift
                        Card.
                      </li>
                      <li>
                        You will be given an option to either replace the
                        lost/stolen card with a physical or virtual card.
                      </li>
                      <li>
                        There is a replacement fee of SGD 5 that will be
                        deducted from the available balance on the abbott Gift
                        Card at the time of re-placement.
                      </li>
                    </ul>
                  </p>
                  <p className={"question"}>
                    &bull; How do I contact Customer Service?
                  </p>
                  <p className={"answer"}>
                    All enquiries in connection with a abbott Gift Card should
                    be made to the Customer Services Contact Centre by calling
                    1880-762-7746.
                  </p>
                  <p className={"question"}>
                    &bull; Can I use my abbott Gift Card for online
                    transactions?
                  </p>
                  <p className={"answer"}>
                    We are currently working towards activating acceptance of
                    the abbott Gift Card on our eCommerce portal and would
                    request you watch this space for more information.
                  </p>
                  <p className={"question"}>
                    &bull; Can I re-load my abbott Gift Card?
                  </p>
                  <p className={"answer"}>
                    abbott Gift Card(s) are not reloadable.
                  </p>
                </div>
              </div>
            </div>

            {/* --- Page Content ends here --- */}
          </div>
        </div>
      </div>
    );
  }
}

AboutUs.propTypes = {
  currentLanguage: PropTypes.string.isRequired
};

const mapStateToProps = ({ auth, locale }) => ({
  currentLanguage: getActiveLanguage(locale).code
});

export default connect(mapStateToProps)(AboutUs);



// WEBPACK FOOTER //
// ./src/views/pages/About.js